import type { ReactNode } from 'react';
import { formatDate } from '@/shared/format';

/** A labelled fact in a definition list. */
export function Field(props: { label: string; value: string; mono?: boolean }): ReactNode {
  return (
    <div>
      <dt className="text-xs tracking-wide text-content-muted uppercase">{props.label}</dt>
      <dd className={props.mono ? 'font-mono text-xs break-all text-content' : 'text-content'}>
        {props.value}
      </dd>
    </div>
  );
}

/** The execution summary facts, shared by both execution detail surfaces. */
export function ExecutionSummary(props: {
  subjectKind: string;
  subjectId: string;
  signerName: string | null;
  signingMethod: string | null;
  completedAt: string | null;
  contentHash: string;
}): ReactNode {
  return (
    <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2">
      <Field label="Subject kind" value={props.subjectKind} />
      <Field label="Subject id" value={props.subjectId} mono />
      <Field label="Signer" value={props.signerName ?? '—'} />
      <Field label="Signing method" value={props.signingMethod ?? '—'} />
      <Field
        label="Completed"
        value={props.completedAt ? formatDate(props.completedAt) : '—'}
      />
      <Field label="Content hash" value={props.contentHash} mono />
    </dl>
  );
}
